import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import ArticleForm from './ArticleForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';


class NewArticleModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            fetching: false,
        };
    }
    submitHandler = ( { article, tags } ) => {
        this.setState( { fetching: true } );
        article.tagIds = tags;
        this.props.createArticle( { ...article } )
        .then( ( newArticle ) => {
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( newArticle );
        } );
    }

    render() {
        const initialValues = { rankedArticle: false };
        return (
            <DLModal title='New Content'
            closeHandler={ this.props.closeModal }>
                <div>
                    <ArticleForm onSubmit={ this.submitHandler } initialValues={ initialValues } />
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }
}
const mapDispatchToProps = () => {
    return {
        createArticle: ( data ) => {
            return dAPI.post( '/admin/content', data );

        },
        updateArticle: ( id, data ) => {
            return dAPI.patch( `/admin/content/${ id }`, dAPI.clean.admin.article( data ) );

        },
    };
};

export default connect( null, mapDispatchToProps )( NewArticleModal );
